var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 160,
    viewBox: "0 0 292 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.58 23.179H17.42C7.8 23.179 0 30.962 0 40.563v81.126c0 9.601 7.8 17.384 17.42 17.384h257.16c9.621 0 17.42-7.783 17.42-17.384V40.563c0-9.601-7.799-17.384-17.42-17.384",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.127 155.662-23.559-40.761c-3.351-5.795.829-13.014 7.532-13.014h47.152c6.702 0 10.883 7.219 7.532 13.014l-23.559 40.761c-3.352 5.795-11.713 5.795-15.065 0zM49.64 23.179S49.773 0 69.682 0s19.909 23.179 19.909 23.179m112.022 1.689S201.746 0 221.655 0s19.909 24.868 19.909 24.868",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41 22.914s-.167-15.596 13.206-15.96 13.339 16.192 13.339 16.192l-26.546-.265zm152.635.265s-1.46-17.484 12.543-17.02 12.609 17.02 12.609 17.02z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.951 23.179s-.166 19.867 8.295 19.867 8.163-19.867 8.163-19.867zm26.413 0s0 19.867 8.295 19.867 8.296-19.867 8.296-19.867zm27.508 0s0 19.867 8.295 19.867 8.295-19.867 8.295-19.867z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h292v160H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog);
export default __webpack_public_path__ + "static/media/Dialog.1829842ad35bd0be631b30d0c6f32352.svg";
export { ForwardRef as ReactComponent };